import { clearPaymentFromSessionStorage } from "@/features/payment/utils";
import { getServerUrl } from "@/lib/runtime-config";
import { useMutation } from "@tanstack/react-query";

export function useRemovePayment() {
  return useMutation({
    mutationFn: async ({
      key,
      cause,
      info,
    }: {
      key: string;
      cause:
        | "inactivity"
        | "cancelled-by-user"
        | "error"
        | "cash-payment-timeout";
      info?: string;
    }) => {
      clearPaymentFromSessionStorage();
      await fetch(`${getServerUrl()}/payment/${key}/remove`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cause,
          info,
        }),
      });
    },
  });
}
